export const svDict = {
  'Account recovery requires verified contact information':
    'För att återställa kontot behöver du ett verifierat konto',
  'An account with the given email already exists.':
    'Det finns redan ett konto med denna e-postadress',
  'Back to Sign In': 'Tillbaka till inloggningen',
  'Change Password': 'Byt lösenord',
  'Confirm Password': 'Bekräfta lösenord',
  Code: 'Kod',
  Confirm: 'Bekräfta',
  'Confirm a Code': 'Bekräfta koden',
  'Confirm Sign In': 'Bekräfta inloggning',
  'Confirm Sign Up': 'Bekräfta registrering',
  'Confirmation Code': 'Verifikationskod',
  'Create a new account': 'Skapa ett nytt konto',
  'Create account': 'Skapa konto',
  'Create Account': 'Skapa konto',
  Email: 'E-post',
  'Enter your password': 'Ange ditt lösenord',
  'Enter your username': 'Ange ditt användarnamn',
  'Forgot Password': 'Glömt lösenordet',
  'Forgot your password?': 'Glömt ditt lösenord? ',
  'Have an account? ': 'Redan registrerad? ',
  'Incorrect username or password': 'Felaktigt användarnamn eller lösenord',
  'Invalid password format': 'Ogiltigt lösenordsformat',
  'Invalid phone number format': `Ogiltigt format för telefonnummer`,
  'Lost your code? ': 'Förlorat koden? ',
  'New Password': 'Nytt lösenord',
  'No account? ': 'Inget konto? ',
  or: 'eller',
  Password: 'Lösenord',
  'Password attempts exceeded':
    'Maximalt antal felaktiga inloggningsförsök har uppnåtts',
  'Phone Number': 'Telefonnummer',
  'Resend Code': 'Skicka koden igen',
  'Reset password': 'Återställ lösenord',
  'Reset your password': 'Återställ ditt lösenord',
  'Send code': 'Skicka kod',
  'Sign in': 'Logga in',
  'Sign In': 'Logga in',
  'Sign in to your account': 'Logga in till ditt konto',
  'Sign Out': 'Logga ut',
  'Sign Up': 'Registrering',
  'We Emailed You': 'Vi har skickat e-post till dig',
  'Enter your code': 'Skriv din kod',
  Skip: 'Hoppa över',
  Submit: 'Skicka',
  'User already exists': 'Användaren finns redan',
  'User does not exist': 'Användaren finns inte',
  Username: 'Användarnamn',
  'Username cannot be empty': 'Användarnamnet kan inte vara tomt',
  Verify: 'Verifiera',
  'Verify Contact': 'Verifiera kontakt',
};
